export default __webpack_public_path__ + "static/media/competition-announcement.1a493e5d.md";